import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from '../environments/environment';
import { Regions, RegionsInfo, SitesShortForm, SiteTanksResponse } from '../interfaces/regions';
import { FeedstockStatus, GetDisposalMethodsBySiteIdResponse, GetDisposalMethodsResponse } from '../interfaces/feedstockstatus';
import { DockTypesResponse, SiteLockCodes } from '../interfaces/sitelockcodes';
import { StreamsList } from '../interfaces/streamsmodel';
import { MaterialUnitOfMeasureLookupResponse, ORHaulerResponse } from '../interfaces/haulerModel';
import { CancelReasonResponse, ExpenseTypeResponse, FeeCategoryLookupResponse, TruckTypesResponse } from '../interfaces/feeCategoryLookupResponse';
import { IdName, SampleFrequencyTypes } from '../interfaces/pricematrixmodel';
import { States } from '../interfaces/states';
import { MMSMenu } from '../interfaces/mmsMenu';
import { DynamicField } from '../interfaces/dynamic-form-model';
import { SDTriggerLookup } from '../interfaces/sdcmodel';

@Injectable({
  providedIn: 'root',
})
export class LookUpService {

  baseUrl = environment.baseUrl;
  constructor(private http: HttpClient) { }

  getMarketsList(marketName: string | ''): Observable<Regions[]> {
    var url = `${this.baseUrl}markets/GetMarketsLookup`;
    return this.http.get<Regions[]>(url);
  }
  getMarketsLookup(): Observable<RegionsInfo[]> {
    var url = `${this.baseUrl}markets/GetMarketsLookup`;
    return this.http.get<RegionsInfo[]>(url);
  }
  getMarketsLookupForProjection(): Observable<RegionsInfo[]> {
    var url = `${this.baseUrl}markets/GetMarketsForLoadProjectionLookUp`;
    return this.http.get<RegionsInfo[]>(url);
  }
  getSiteTypes(): Observable<IdName[]> {
    var url = `${this.baseUrl}masters/GetSiteTypes`;
    return this.http.get<IdName[]>(url);
  }

  getRPCTypes(): Observable<IdName[]> {
    var url = `${this.baseUrl}masters/GetRPCTypesLookup`;
    return this.http.get<IdName[]>(url);
  }

  getMarketsByMarket(marketName: string | ''): Observable<Regions[]> {
    var url = `${this.baseUrl}markets?name=`;
    return this.http.get<Regions[]>(url);
  }

  getStreamsByMarketAndGenerator(
    marketsIds: string,
    genIds: string
  ): Observable<StreamsList[]> {
    var url = `${this.baseUrl}streams?marketIds=${marketsIds}&genIds=${genIds}`;
    return this.http.get<StreamsList[]>(url);
  }

  getSitesByMarketId(
    regionId: number,
    scheduleType: number
  ): Observable<SitesShortForm[]> {
    var url = `${this.baseUrl}Sites/GetRegionalSites?regionId=${regionId}&scheduletypeId=${scheduleType}`;
    return this.http.get<SitesShortForm[]>(url);
  }//

  getLPSites(): Observable<SitesShortForm[]> {
    var url = `${this.baseUrl}Sites/GetLoadProjectionSites`;
    return this.http.get<SitesShortForm[]>(url);
  }//GetLoadProjectionSites

  getADSitesByMarketId(
    regionId: number,
    scheduleType: number): Observable<SitesShortForm[]>{
    //GetADSites
    var url = `${this.baseUrl}masters/GetADSites?regionId=${regionId}&scheduletypeId=${scheduleType}`;
    return this.http.get<SitesShortForm[]>(url);
  }

  getddSites(
  ): Observable<SitesShortForm[]> {
    var url = `${this.baseUrl}dailydosing/GetDailyDosingSites`;
    return this.http.get<SitesShortForm[]>(url);
  }
  
  getStatusInfo(): Observable<any[]>{
    var retData = [
      {id: 0, name: 'Success', code: 'S'},
      {id: 1, name: 'Failure', code: 'F'},
    ];
    return of(retData);
  }

  getSiteTanksBySiteId(siteid: string): Observable<SiteTanksResponse[]> {
    var url = `${this.baseUrl}Sites/GetSiteTanksBySiteId?SiteId=${siteid}`;
    return this.http.get<SiteTanksResponse[]>(url);
  }

  getDisposalSitesFromPriceMatrixLookup(customerId: string, streamId: string, scheduleType: string, actualDate: string | null): Observable<SitesShortForm[]> {
    var url = '';
    if (actualDate == null) {
      url = `${this.baseUrl}Sites/GetDisposalSitesFromPriceMatrixLookup?CustomerID=${customerId}&StreamID=${streamId}&ScheduleTypeid=${scheduleType}`;
    } else {
      url = `${this.baseUrl}Sites/GetDisposalSitesFromPriceMatrixLookup?CustomerID=${customerId}&StreamID=${streamId}&ScheduleTypeid=${scheduleType}&ActualDate=${actualDate}`;
    }
    return this.http.get<SitesShortForm[]>(url);
  }

  getLockCodesBySitesId(siteId: string): Observable<SiteLockCodes[]> {
    var url = `${this.baseUrl}Sites/GetSiteLockCodes?sid=${siteId}`;
    return this.http.get<SiteLockCodes[]>(url);
  }

  getFeeCategories(): Observable<SiteLockCodes[]> {
    var url = `${this.baseUrl}Sites/GetSiteLockCodes`;
    return this.http.get<SiteLockCodes[]>(url);
  }

  getDocTypes(): Observable<DockTypesResponse[]> {
    var url = `${this.baseUrl}masters/GetDocTypes`;
    return this.http.get<DockTypesResponse[]>(url);
  }

  getDocTypeByScreenType(screenTypeId: number): Observable<DockTypesResponse[]> {
    var url = `${this.baseUrl}masters/GetDocTypes?screenTypeId=${screenTypeId}`;
    return this.http.get<DockTypesResponse[]>(url);
  }

  getHaulers(marketId: string | null): Observable<ORHaulerResponse[]> {
    var url = `${this.baseUrl}haulers?marketId=${marketId}`;
    return this.http.get<ORHaulerResponse[]>(url);
  }

  feeCategories(): Observable<FeeCategoryLookupResponse[]> {
    var url = `${this.baseUrl}masters/GetFeeCategoryLookup`;
    return this.http.get<FeeCategoryLookupResponse[]>(url);
  }

  getInternalSiteHaulCostReasons(): Observable<IdName[]> {
    var url = `${this.baseUrl}masters/GetInternalSiteHaulCostReasons`;
    return this.http.get<IdName[]>(url);
  }

  getTruckTypes(): Observable<TruckTypesResponse[]> {
    var url = `${this.baseUrl}masters/GetTruckTypes`;
    return this.http.get<TruckTypesResponse[]>(url);
  }

  getToteRentalTypes(): Observable<IdName[]> {
    var url = `${this.baseUrl}masters/GetToteRentalTypes`;
    return this.http.get<IdName[]>(url);
  }

  getToteRentalSizes(): Observable<IdName[]> {
    var url = `${this.baseUrl}masters/GetToteRentalSizes`;
    return this.http.get<IdName[]>(url);
  }

  getExpenseTypes(): Observable<ExpenseTypeResponse[]> {
    var url = `${this.baseUrl}masters/GetExpenseTypes`;
    return this.http.get<ExpenseTypeResponse[]>(url);
  }

  getDisposalMethods(siteId: string): Observable<GetDisposalMethodsBySiteIdResponse[]> {
    var url = `${this.baseUrl}masters/GetDisposalMethodsBySite?siteId=${siteId}`;
    return this.http.get<GetDisposalMethodsBySiteIdResponse[]>(url);
  }

  getAllDisposalMethods(): Observable<GetDisposalMethodsResponse[]> {
    var url = `${this.baseUrl}streams/GetDisposalMethods`;
    return this.http.get<GetDisposalMethodsResponse[]>(url);
  }

  getMaterialUnitOfMeasureLookup(typeid: number): Observable<MaterialUnitOfMeasureLookupResponse[]> {
    var url = `${this.baseUrl}masters/GetMaterialUnitOfMeasureLookup?type=${typeid}`;
    return this.http.get<MaterialUnitOfMeasureLookupResponse[]>(url);
  }

  getStatesList(): Observable<States[]> {
    var url = `${this.baseUrl}masters/GetUSStates`;
    return this.http.get<States[]>(url);
  }

  getPackageTypes(): Observable<IdName[]> {
    var url = `${this.baseUrl}masters/GetPackageTypes`;
    return this.http.get<IdName[]>(url);
  }

  getAllEmployeesLookUp(): Observable<IdName[]> {
    var url = `${this.baseUrl}masters/GetAllEmployeesLookUp`;
    return this.http.get<IdName[]>(url);
  }

  getFoodGroup(): Observable<IdName[]> {
    var url = `${this.baseUrl}streams/GetFoodGroupLookUp`;
    return this.http.get<IdName[]>(url);
  }

  getLabTypes(): Observable<IdName[]> {
    var url = `${this.baseUrl}masters/GetLabsLookUp`;
    return this.http.get<IdName[]>(url);
  }

  getFoodMatrix(): Observable<IdName[]> {
    var url = `${this.baseUrl}streams/GetFoodMatrixLookUp`;
    return this.http.get<IdName[]>(url);
  }

  getStreamStrengthLookUp(): Observable<IdName[]> {
    var url = `${this.baseUrl}streams/GetStreamStrengthLookUp`;
    return this.http.get<IdName[]>(url);
  }

  getSalesRep(): Observable<IdName[]> {
    var url = `${this.baseUrl}streams/GetSalesrepLookUp`;
    return this.http.get<IdName[]>(url);
  }

  getORHaulers(): Observable<IdName[]> {
    var url = `${this.baseUrl}streams/GetORHaulersLookUp`;
    return this.http.get<IdName[]>(url);
  }

  getCancelReasons(): Observable<CancelReasonResponse[]> {
    var url = `${this.baseUrl}masters/GetCancelReasons`;
    return this.http.get<CancelReasonResponse[]>(url);
  }

  getMmsMenus(roleName: string): Observable<MMSMenu[]> {
    var url = `${this.baseUrl}user/GetMenusByRole?rolename=${roleName}`;
    return this.http.get<MMSMenu[]>(url);
  }

  getSampleFrequencyLookup(): Observable<SampleFrequencyTypes[]> {
    var url = `${this.baseUrl}streams/GetSamplingFrequencyLookUp`;
    return this.http.get<SampleFrequencyTypes[]>(url);
  }

  GetUISchema(entityName: string): Observable<DynamicField[]> {
    var url = `${this.baseUrl}masters/GetUIDynamicFormFieldSchema?entityname=${entityName}`;
    return this.http.get<DynamicField[]>(url);
  }

  getDataOverrideSites(): Observable<SitesShortForm[]> {
    var url = `${this.baseUrl}Sites/GetDataOverrideSites`;
    return this.http.get<SitesShortForm[]>(url);
  }

  getSDTriggerLookup(): Observable<SDTriggerLookup[]> {
    const url = `${this.baseUrl}masters/GetSDTriggerLookup`;
    return this.http.get<SDTriggerLookup[]>(url);
  }
}
